<template class="">
  <div>
  <div v-if="!isNewItem">
    <div class="input-text-size pa-0 ma-0 custom-red-text">{{ errorMessage || ''}}</div>
    <div v-if="ownerName!=''" class="input-text-size pa-0 ma-0 pl-6">
  <span class="font-weight-bold">Owner Name:</span> {{ ownerName || 'N/A' }}
</div>
    <div class="scrollable-ctnr pt-6 pb-0 ma-0">
  <v-row dense justify="space-around" class="">
    <v-col cols="5" class="pt-0 pb-0">
      <v-text-field class='input-text-size pa-0 ma-n3'
      v-model.number="editedItem.systemId"
      readonly>
        <template v-slot:label>
          <label>System ID</label>
        </template>
      </v-text-field>
      <CommonDropDowns
      @change="dataFromCommonDropDowns"
      :isItTaxYearWithoutAllYears=true
     :taxYearValue="editedItem.taxYear"
      class="ml-n3 mr-2 my-2"/>
      <v-text-field class='input-text-size pa-0 ma-n3'
      v-model.number="editedItem.taxId"
      @change="handleTaxInquiry"
      >
       <template v-slot:label>
          <label>Tax ID</label>
        </template>
      </v-text-field>
      <v-text-field class='input-text-size pa-0 ma-n3'
      readonly tabindex="-1"
      v-model.number="editedItem.propertyOrParcelId">
        <template v-slot:label>
          <label>Parcel ID</label>
        </template>
      </v-text-field>
      <v-text-field class='input-text-size pa-0 ma-n3'
      v-model.number="editedItem.warrantNumber">
        <template v-slot:label>
          <label>Warrant No</label>
        </template>
      </v-text-field>
      <v-text-field class='input-text-size pa-0 ma-n3'
      v-model.number="editedItem.aliasNumber">
        <template v-slot:label>
          <label>Alias#</label>
        </template>
      </v-text-field>
      <ClarionDateControl class='input-text-size pa-0 my-n5 ml-n3 mr-3'
      :isRequired='false' :isToggle=false
       :isIsoDate="true"
        label='Issue Date'
        v-model="editedItem.issueDate"/>
      <v-text-field class='input-text-size pa-0 mx-n3 my-2'
      v-model.number='editedItem.issueAmount'
      @blur="roundAmount('issueAmount')"
      @focus="amountToNum('issueAmount')">
        <template v-slot:label>
          <label>Issue Amount</label>
        </template>
      </v-text-field>
      <v-text-field class='input-text-size pa-0 mx-n3 my-2'
      v-model.number='editedItem.amountCollected'
      @blur="roundAmount('amountCollected')"
      @focus="amountToNum('amountCollected')">
        <template v-slot:label>
          <label>Amount Collected</label>
        </template>
      </v-text-field>
      <ClarionDateControl class='input-text-size pa-0 my-n5 ml-n3 mr-3'
      :isRequired='false' :isToggle=false
       :isIsoDate="true"
      v-model="editedItem.servedDate"
        label='Served Date' />

        <ClarionDateControl class='input-text-size pa-0 my-n5 ml-n3 mr-3'
        :isToggle="false"
        :isIsoDate="true"
        :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
         v-model="editedItem.penaltyDate" label="Penalty Date" />

      <div class="d-flex  align-center justify-start mt-n3 " >
        <p class="input-text-size pt-0 pr-4">Active ?</p>
        <v-checkbox class="pb-3 "
        v-model= "editedItem.isActive"
         :label="``"></v-checkbox>
      </div>
    </v-col>
    <v-col cols="5" class="pt-0 pb-0">
      <v-text-field
        class='input-text-size pa-0 ma-n3'
        v-model="editedItem.name1" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>Name 1</label>
        </template>
      </v-text-field>
      <v-text-field
        class='input-text-size pa-0 ma-n3'
        v-model="editedItem.name2" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>Name 2</label>
        </template>
      </v-text-field>
      <v-text-field
        class='input-text-size pa-0 ma-n3'
        :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
        v-model="editedItem.inCareOf1" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>In Care Of 1</label>
        </template>
      </v-text-field>
      <v-text-field
        class='input-text-size pa-0 ma-n3'
        :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
        v-model="editedItem.inCareOf2" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>In Care Of 2</label>
        </template>
      </v-text-field>
      <v-text-field class='input-text-size pa-0 ma-n3'
      v-model="editedItem.address1" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>Address 1</label>
        </template>
      </v-text-field>
      <v-text-field class='input-text-size pa-0 ma-n3'
      v-model="editedItem.address2" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>Address 2</label>
        </template>
      </v-text-field><v-text-field class='input-text-size pa-0 ma-n3'
      v-model="editedItem.address3" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>Address 3</label>
        </template>
      </v-text-field><v-text-field class='input-text-size pa-0 ma-n3'
      v-model="editedItem.address4" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>Address 4</label>
        </template>
      </v-text-field>
      <v-text-field
        class='input-text-size pa-0 ma-n3'
        v-model="editedItem.city" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>City</label>
        </template>
      </v-text-field>
      <v-text-field
        class='input-text-size pa-0 ma-n3'
        v-model="editedItem.state" v-uppercase="isEverythingToCaps">
        <template v-slot:label>
          <label>State</label>
        </template>
      </v-text-field>
      <v-text-field
        class='input-text-size pa-0 ma-n3'
        v-model="editedItem.zip">
        <template v-slot:label>
          <label>Zip</label>
        </template>
      </v-text-field>
      <v-textarea class="input-text-size pa-0 ma-n3" outlined
      v-model="editedItem.remarks"
      v-textAreaUppercase=globalSettingItem.conEverythingToCaps  >
        <template v-slot:label>
          <label class="label">Remarks</label>
        </template>
      </v-textarea>
      <CommonDropDowns class="pa-0 mt-n5 mr-5" :isItstaCode=true
                   @change="dataFromCommonDropDowns"
                    :staCodeValue="editedItem.statusCode" />
      <v-card-actions class="justify-end">
        <v-btn color='primary' small @click="openRenewFeesDialog">
          Renew This Warrant
        </v-btn>
      </v-card-actions>

      <v-dialog v-model="renewFeesDialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h5">
            Renew Fees
          </v-card-title>
          <v-card-text class="input-text-size">
            This renewal can re-incur the following fees. Uncheck a fee to skip
            adding it on this renewal.
            <v-checkbox dense hide-details class="mt-3"
              v-model="renewFeeSelection.sheriff"
              :label="formatRenewFeeLabel(sheriffFeeInfo)" />
            <v-checkbox dense hide-details class="mt-1"
              v-model="renewFeeSelection.treasurer"
              :label="formatRenewFeeLabel(treasurerFeeInfo)" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small @click="cancelRenewFees">
              Cancel
            </v-btn>
            <v-btn color="primary" text small @click="confirmRenewFees">
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
  <WarrantDetailsList />
</div>
  </div>
  <div v-if="isNewItem">
    <div class="input-text-size pa-0 ma-0 custom-red-text">{{ errorMessage || ''}}</div>
        <div v-if="ownerName!=''" class="input-text-size pa-0 ma-0">
  <span class="font-weight-bold">Owner Name:</span> {{ ownerName || 'N/A' }}
</div>
            <div class="scrollable-ctnr pt-6 pb-0 ma-0">
            <v-row dense justify="space-around" class="">
            <v-col cols='6' class='pt-0 pb-0 my-n4'>
              <CommonDropDowns :isItTaxYearWithoutAllYears=true
              :taxYearValue="editedItem.taxYear"
              @change="dataFromCommonDropDowns"/></v-col>
                <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0'
                  v-model.number="editedItem.taxId"
                   @change="handleTaxInquiry"
                  >
                  <template v-slot:label>
                    <label>TID</label>
                  </template>
                </v-text-field></v-col>
                <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0'
                  v-model.number="editedItem.warrantNumber"
                  >
                  <template v-slot:label>
                    <label>Warrant No</label>
                  </template>
                </v-text-field>
                </v-col>
                <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0'
                  v-model.number="editedItem.aliasNumber" >
                  <template v-slot:label>
                    <label>Alias No</label>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="">
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0 ' readonly
                  v-model="editedItem.sherifFee">
                  <template v-slot:label>
                    <label>Sheriff Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 ">
                  <v-text-field class='input-text-size pa-0 ma-0 '
                  v-model.number="editedItem.sherifFeeAmount"
                  @blur="roundAmount('sherifFeeAmount')"
                  @focus="amountToNum('sherifFeeAmount')">
                  <template v-slot:label>
                    <label>Sheriff Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0' readonly
                  v-model="editedItem.treasureFee">
                  <template v-slot:label>
                    <label>Treasurer Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0'
                  v-model.number="editedItem.treasureFeeAmount"
                  @blur="roundAmount('treasureFeeAmount')"
                  @focus="amountToNum('treasureFeeAmount')">
                  <template v-slot:label>
                    <label>Treasurer Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
               <v-col cols="6" class="pt-0 pb-0">
                 <ClarionDateControl  class=' input-text-size pa-0 ma-0'
                :isToggle="false"
                :isIsoDate="true"
                :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
                 v-model="editedItem.penaltyDate" label="Penalty Date" />
               </v-col>

            </v-row>
          </div>

        </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import WarrantDetailsList from './TaxWarrantsDetailsList.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import { TaxWarrantsDialogMixin } from './utils/taxWarrants.mixin';
import {
  warrantAmountUtils,
} from './utils/taxWarrants.util';
import { amountToNumber, amountFormat } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import InCareOfSetting from '../common-utils/inCareOf.mixin';

export default {
  name: 'WarrantDialog',
  mixins: [TaxWarrantsDialogMixin, CommonDropDowns, GlobalToCaps, InCareOfSetting],
  components: {
    WarrantDetailsList,
    ClarionDateControl,
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    errorMessage: null,
    renewFeesDialog: false,
    // Defaults to both checked - the fees a renewal re-incurs unless the user opts out.
    renewFeeSelection: { sheriff: true, treasurer: true },
  }),
  computed: {
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData || [],
    }),
    isNewItem() {
      return !this.editedItem || !this.editedItem._id;
    },
    checkTaxStatus() {
      return this.editedItem && this.editedItem.isActive === true;
    },
    ownerName() {
      if (!this.editedItem) return '';
      return `${this.editedItem.name1 || ''}  ${this.editedItem.name2 || ''}`;
    },
    statusCodeList() {
      return [];
    },
    // Same Tax Settings source BrowseTrWorkFile.vue reads for a brand-new warrant's fees
    // (createNewWarrantItem) - a renewal re-incurs the same two PTW fees.
    sheriffFeeInfo() {
      return this.buildRenewFeeInfo(
        this.taxSettingItem.sherifFee, this.taxSettingItem.sherifFeeAmount,
      );
    },
    treasurerFeeInfo() {
      return this.buildRenewFeeInfo(
        this.taxSettingItem.treasurerFee, this.taxSettingItem.treasurerFeeAmount,
      );
    },
  },

  mounted() {
    this.initializeAmountFormat();
    if (!this.taxFeeMasterData.length) {
      this.loadTaxFeeMasterTypes({ criteria: {} });
    }
  },

  methods: {
    ...mapActions('shared/taxFeeMaster', ['loadTaxFeeMasterTypes']),

    // Override mixin methods to use the same CRUD key for both operations
    getEditedItemCrudKey() {
      return this.baseCrudKey;
    },

    getUpsertCrudKey() {
      return this.baseCrudKey;
    },

    buildRenewFeeInfo(feeNumber, feeAmount) {
      const number = (feeNumber || '').toString();
      const master = this.taxFeeMasterData.find(
        (fee) => (fee.feeNumber || '').toString() === number,
      );
      return {
        number,
        description: (master && master.feeDescription) || '',
        amount: amountToNumber(feeAmount) || 0,
      };
    },

    formatRenewFeeLabel(feeInfo) {
      const description = feeInfo.description ? ` ${feeInfo.description}` : '';
      return `${feeInfo.number}${description} - ${amountFormat(feeInfo.amount)}`;
    },

    openRenewFeesDialog() {
      this.renewFeeSelection = { sheriff: true, treasurer: true };
      this.renewFeesDialog = true;
    },

    cancelRenewFees() {
      this.renewFeesDialog = false;
    },

    async confirmRenewFees() {
      this.renewFeesDialog = false;
      await this.upsertTransaction();
    },

    // Override the base upsert method with component-specific logic
    async beforeUpsert(item) {
      // Custom pre-upsert logic for warrant dialog
      const updatedItem = item;
      updatedItem.aliasNumber = warrantAmountUtils.toNumber(updatedItem.aliasNumber) + 1;
      updatedItem.renew = true;

      // Re-incur only the fees the user left checked in the renew-fees dialog. The code/amount
      // charged is stored back onto the warrant header (same fields a brand-new warrant sets)
      // so the record reflects what was actually charged on this renewal - a zero amount
      // for an unchecked fee tells the backend's upsertPTWFeesInTaxInquiry to skip it.
      updatedItem.sherifFee = this.sheriffFeeInfo.number;
      updatedItem.sherifFeeAmount = this.renewFeeSelection.sheriff ? this.sheriffFeeInfo.amount : 0;
      updatedItem.treasureFee = this.treasurerFeeInfo.number;
      updatedItem.treasureFeeAmount = this.renewFeeSelection.treasurer
        ? this.treasurerFeeInfo.amount : 0;

      return updatedItem;
    },

    // Custom amount formatting for this component
    initializeAmountFormat() {
      if (!this.editedItem) return;

      const keys = ['sherifFeeAmount', 'treasureFeeAmount', 'issueAmount', 'amountCollected'];
      keys.forEach((key) => {
        const value = this.editedItem[key];
        // Skip individual field if it's 0, undefined, or null (each checked independently)
        if (value === undefined || value === null || value === 0 || value === '') {
          return;
        }
        this.roundAmount(key);
      });
    },
  },
};
</script>

<style scoped>
.custom-red-text {
  color: red;
  font-weight: bold;
}
</style>
